/**
 * Novilot brand mark — a fountain-pen nib (writing, not a letter).
 * Single-color: inherits `currentColor`, so `className="text-accent"` tints it
 * exactly like the Lucide icons it replaces. The breather hole and tine slit
 * are cut out (evenodd) so it works on any background.
 */
export function NovilotMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6 5.1C7.4 3.4 9.6 2.4 12 2.4s4.6 1 6.4 2.7c.34.32.43.82.22 1.24C16.2 11.4 13.9 16.6 12.6 21.1a.63.63 0 0 1-1.2 0C10.1 16.6 7.8 11.4 5.38 6.35a1 1 0 0 1 .22-1.25Zm6.4 1.7a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Zm-.62 4.98a.62.62 0 0 1 1.24 0l-.62 7.8-.62-7.8Z"
      />
    </svg>
  );
}
